<template>
  <div
    v-loading="loading"
    class="main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="section operations">
      <div class="triggers">
        <div>
          <div class="input-label">{{ $t('CargoMsg.Cargo_Filter') }}</div>
          <el-input v-model="keyword" style="width: 180px;" />
          <el-button v-permission="['button_AirRoute_add']" type="primary" @click="newHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button v-permission="['button_AirRoute_edit']" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button v-permission="['button_AirRoute_delete']" type="primary" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </div>
      </div>
    </div>
    <div style="flex-grow: 1;min-height: 350px;">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="filteredRowData"
        style="height: 100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="routeDialog.visible"
      :title="routeDialog.title"
      width="420px"
      :close-on-click-modal="false"
      class="route-form"
    >
      <el-form :label-width="$selectByLang('100px', '120px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_Code')" class="lable-blue">
          <el-input v-model="routeDialog.form.code" :placeholder="$t('CargoMsg.Cargo_MustBEntered')" style="width: 150px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Name')" class="lable-blue">
          <el-input v-model="routeDialog.form.name" :placeholder="$t('CargoMsg.Cargo_MustBEntered')" style="width: 150px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')">
          <el-input v-model="routeDialog.form.englishName" placeholder=" " style="width: 180px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_OriginRegionCode')" class="lable-blue">
          <cargo-advance-select
            :select-type="TYPE_NAMES.static_data_AirRegion"
            :cache="false"
            :static-options="routeDialog.airRegionList"
            :show-custom-label-in-option="true"
            :custom-label="airRegionLabel"
            filterable
            :default-value="routeDialog.form.originRegionCode"
            :placeholder="$t('CargoMsg.Cargo_MustBEntered')"
            style="width: 230px;"
            @parentCallBack="p=>{routeDialog.form.originRegionCode=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_TargetRegionCode')" class="lable-blue">
          <cargo-advance-select
            :select-type="TYPE_NAMES.static_data_AirRegion"
            :cache="false"
            :static-options="routeDialog.airRegionList"
            :show-custom-label-in-option="true"
            :custom-label="airRegionLabel"
            filterable
            :default-value="routeDialog.form.targetRegionCode"
            :placeholder="$t('CargoMsg.Cargo_MustBEntered')"
            style="width: 230px;"
            @parentCallBack="p=>{routeDialog.form.targetRegionCode=p.value}"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="routeDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { loadSpecificBasicInfo } from '@/api/cache'
import { saveAirRoute, deleteAirRoute } from '@/api/basicData/airRoute'

export default {
  name: 'AirRouteList',
  components: { cargoAdvanceSelect },
  data() {
    return {
      loading: false,
      TYPE_NAMES,
      keyword: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onCellDoubleClicked: event => {
          if (this.$checkPermission(['button_AirRegion_edit'])) {
            this.editHandler()
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'name',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 140
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginRegionCode'),
          field: 'originRegionCode',
          width: 140
        }, {
          headerName: this.$t('CargoMsg.Cargo_TargetRegionCode'),
          field: 'targetRegionCode',
          width: 140
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      routeDialog: {
        visible: false,
        title: '',
        form: { code: '', name: '', englishName: '', originRegionCode: '', targetRegionCode: '' },
        airRegionList: []
      }
    }
  },
  computed: {
    filteredRowData() {
      return this.rowData.filter(p => {
        const keyword = this.keyword.trim()
        if (!keyword) {
          return true
        }
        if (p.code.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.englishName.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.originRegionCode.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        if (p.targetRegionCode.toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
          return true
        }
        return false
      })
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    queryHandler() {
      this.loading = true
      loadSpecificBasicInfo('AirRoute').then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    async newHandler() {
      this.routeDialog.title = this.$t('CargoMsg.Cargo_NewRoute')
      this.routeDialog.form = { code: '', name: '', englishName: '', originRegionCode: '', targetRegionCode: '' }
      await loadSpecificBasicInfo('AirRegion').then(res => {
        this.routeDialog.airRegionList = res.data
      })
      this.routeDialog.visible = true
    },
    async editHandler() {
      if (!this.selectedNode) {
        return
      }
      const data = this.selectedNode.data
      this.routeDialog.title = this.$t('CargoMsg.Cargo_EditRoute')
      this.routeDialog.form = { ...data }
      await loadSpecificBasicInfo('AirRegion').then(res => {
        this.routeDialog.airRegionList = res.data
      })
      this.routeDialog.visible = true
    },
    airRegionLabel(item) {
      if (item) {
        return '[' + item.code + ']' + item.name
      }
      return ''
    },
    commitHandler() {
      const form = this.routeDialog.form
      if (!form.code.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseEnterACode'))
        return
      }
      if (this.rowData.findIndex(p => p.code === form.code && p.uuid !== form.uuid) > -1) {
        this.$message.warning(this.$t('AirExport.CodeExistsPleaseReEnter'))
        return
      }
      if (!form.name.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseEnterAName'))
        return
      }
      if (!form.originRegionCode) {
        this.$message.warning(this.$t('AirExport.PleaseTheDepartureRegionCode'))
        return
      }
      if (!form.targetRegionCode) {
        this.$message.warning(this.$t('AirExport.PleaseTheDestinationRegionCode'))
        return
      }
      if (form.originRegionCode === form.targetRegionCode) {
        this.$message.warning(this.$t('AirExport.DepartureRegionCodeCannotSame'))
        return
      }
      this.loading = true
      saveAirRoute(form).then(res => {
        this.queryHandler()
        this.routeDialog.visible = false
      }).catch(() => {
        this.loading = false
      })
    },
    delHandler() {
      if (this.selectedNode) {
        this.$confirm(this.$t('AirExport.AreYouWantToDelete'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.loading = true
          deleteAirRoute({ uuid: this.selectedNode.data.uuid }).then(res => {
            this.queryHandler()
          }).catch(() => {
            this.loading = false
          })
        }).catch()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.route-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
</style>
